import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import InfoIcon from '@mui/icons-material/Info';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import InfoTwoToneIcon from '@mui/icons-material/InfoTwoTone';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import ChatBubbleTwoToneIcon from '@mui/icons-material/ChatBubbleTwoTone';
import ChatIcon from '@mui/icons-material/Chat';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import ChatTwoToneIcon from '@mui/icons-material/ChatTwoTone';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import AnnouncementOutlinedIcon from '@mui/icons-material/AnnouncementOutlined';
import AnnouncementTwoToneIcon from '@mui/icons-material/AnnouncementTwoTone';
import CommentIcon from '@mui/icons-material/Comment';
import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined';
import CommentTwoToneIcon from '@mui/icons-material/CommentTwoTone';
import ModeCommentIcon from '@mui/icons-material/ModeComment';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import {styled} from "@mui/material/styles";
import PortalQuestion from "./PortalQuestionHook";
import {
    answerQuestionOptions,
    answerQuestionTemplateOptions,
    answerQuestionText,
    answerQuestionTextInStore,
    answerQuestionTemplateText,
    onChangeQuestionText
} from "./actions/portalActions";
import {getCategoryTitleBar} from "./utilities/getCategoryTitleBar";
import * as custom from "./utilities/getCustomTypography";
import * as font from "./utilities/fontUtilities";
import * as ddo from "./constants/customObjConstants";
import * as tag from "./constants/customMetadataConstants";
import * as portalShared from "./shared/metadataConstantsAndUtilities"
import * as requiredUtil from "./utilities/requiredUtilities";
import {imageDataUri} from "../utilities/imageCompression";
import green_checkmark from './constants/green_checkmark.png'
import * as showGroupUtil from "./utilities/showGroupUtilities";


const descriptionIcons= {
    "InfoIcon": InfoIcon,
    "InfoOutlinedIcon": InfoOutlinedIcon,
    "InfoTwoToneIcon": InfoTwoToneIcon,
    "ChatBubbleIcon": ChatBubbleIcon,
    "ChatBubbleOutlineOutlinedIcon": ChatBubbleOutlineOutlinedIcon,
    "ChatBubbleTwoToneIcon": ChatBubbleTwoToneIcon,
    "ChatIcon": ChatIcon,
    "ChatOutlinedIcon": ChatOutlinedIcon,
    "ChatTwoToneIcon": ChatTwoToneIcon,
    "AnnouncementIcon": AnnouncementIcon,
    "AnnouncementOutlinedIcon": AnnouncementOutlinedIcon,
    "AnnouncementTwoToneIcon": AnnouncementTwoToneIcon,
    "CommentIcon": CommentIcon,
    "CommentOutlinedIcon": CommentOutlinedIcon,
    "CommentTwoToneIcon": CommentTwoToneIcon,
    "ModeCommentIcon": ModeCommentIcon,
    "FiberManualRecordIcon": FiberManualRecordIcon,
    "PanoramaFishEyeIcon": PanoramaFishEyeIcon,
    "HorizontalRuleIcon": HorizontalRuleIcon
};


function PortalPageRenderer(props) {

    // -----------------------------------------------------------------------------------------------------------------
    // Add  Page Object
    // -----------------------------------------------------------------------------------------------------------------

    const getQnrObj = () => {

        let qnr;
        if (props.portalPreview) {
            qnr = (props.questionnaireTemplateFromStore !== null) ? props.questionnaireTemplateFromStore : props.questionnaireTemplate;
        }
        else {
            // On Portal Preview second load on the same screen we are getting an empty object {} this is to account for that!
            let tempQuestionnaireInstance = portalShared.cloneObj(props.questionnaireInstance);
            if (tempQuestionnaireInstance !== null) {
                let tempQuestionnaireInstanceString = JSON.stringify(tempQuestionnaireInstance);
                if (tempQuestionnaireInstanceString === "{}") {
                    tempQuestionnaireInstance = null;
                }
            }

            qnr = props.questionnaireInstance;
        }

        return portalShared.cloneObj(qnr);
    }

    const addSectionToPage = (qnr, sectionObj, pageNum, sectionNum, numberOfPages) => {
        // Get an array of item objects in this section
        let sectionItems = ddo.getObjValue(sectionObj, ddo.OBJ.KEY.PAGE.SECTION.ITEM_ARRAY);

        // Convert the stored values to the actual text
        let justify = ddo.getObjValueWithConversion(sectionObj, ddo.OBJ.KEY.PAGE.SECTION.JUSTIFY);
        let alignItems = ddo.getObjValueWithConversion(sectionObj, ddo.OBJ.KEY.PAGE.SECTION.ALIGN_ITEMS);
        let classType = ddo.getObjValueWithConversion(sectionObj, ddo.OBJ.KEY.PAGE.SECTION.CLASS_TYPE);

        //let qnr = this.getQnrObj(); // Get Questionnaire Obj (Instance or Template)

        let sectionClass = {padding: "8px 8px 8px 8px"}; // controlGrid
        if (classType === ddo.SECTION.CLASS_TYPE.FOOTER) {
            sectionClass = {padding: "10px 16px", borderTop: "solid rgba(0, 0, 0, 0.1) 1px", width: "100%"}; // footerGrid
        }
        // switch (classType) {
        //     case ddo.SECTION.CLASS_TYPE.CONTROL:
        //         sectionClass = this.props.classes.controlGrid;
        //         break;
        //     case ddo.SECTION.CLASS_TYPE.FOOTER:
        //         sectionClass = this.props.classes.footerGrid;
        //         break;
        //     default:
        //         break;
        // }

        let divAndKeyName = "Section-" + pageNum + "-" + sectionNum;

        if (sectionItems[0].type === "LIKERT_GROUP") {

            // Fix for when create group likert but actual showGroup has not been created yet
            let questionsArray = sectionItems[0].questions;
            let showGroupKey = questionsArray.length ? showGroupUtil.showGroup(qnr, questionsArray[0].showGroupKey) : false;
            return (
                <div id={divAndKeyName} key={divAndKeyName} style={{width: "100%", display: showGroupKey ? "inline" : "none"}}>
                    <Grid
                        id={"OuterGridA-" + pageNum + "-" + sectionNum}
                        key={"Section-" + pageNum + "-" + sectionNum}
                        container
                        justifyContent={justify}
                        alignItems={alignItems}
                        style={{
                            ...sectionClass,
                            overflow: "unset"
                        }}>
                        {sectionItems.map((item, index) => addItemToSection(qnr, item, pageNum, sectionNum, index, numberOfPages, sectionClass))}
                    </Grid>
                </div>
            );
        }
//         else if (true) {
// debugger;
//             // Fix for when create group likert but actual showGroup has not been created yet
//             //let questionsArray = sectionItems[0].questions;
//             //let showGroupKey = questionsArray.length ? showGroupUtil.showGroup(questionsArray[0].showGroupKey) : false;
//             return (
//                 <div id={divAndKeyName} key={divAndKeyName} style={{display: sectionItems[0].showGroupKey ? "inline" : "none"}}>
//                     <Grid
//                         id={"OuterGridA-" + pageNum + "-" + sectionNum}
//                         key={"Section-" + pageNum + "-" + sectionNum}
//                         container
//                         justifyContent={justify}
//                         alignItems={alignItems}
//                         style={{
//                             ...sectionClass,
//                             overflow: 'unset'
//                         }}>
//                         {this.addItemToSection(qnr, sectionItems[0], pageNum, sectionNum, 0, numberOfPages, sectionClass)}
//                     </Grid>
//                 </div>
//             );
//
//         }
        else if (sectionItems[0].format === "TITLE_FORMAT_METADATA") {
            // ZZZZZ QQQQQ YYYYY
            // This is for readonly mode to display metadata at top of survey
            // Reorder array so "Date Surveyed" is the Top Item
            let newSectionItems = [];
            let splitName = null;
            let dateIndex = 0;
            for (let i = 0; i < sectionItems.length; i++) {
                splitName = sectionItems[i].name.split("|");
                if (splitName[0] === "Date Surveyed") {
                    newSectionItems.push(sectionItems[i]);
                    dateIndex = i;
                    break;
                }
            }

            for (let ii = 0; ii < sectionItems.length; ii++) {
                splitName = sectionItems[ii].name.split("|");
                if (dateIndex !== ii) {
                    newSectionItems.push(sectionItems[ii]);
                }
            }

            return (
                <div id={divAndKeyName} key={divAndKeyName}>
                    <Grid
                        id={"OuterGridB-" + pageNum + "-" + sectionNum}
                        key={"Section-" + pageNum + "-" + sectionNum}
                        container
                        justifyContent={justify}
                        alignItems={alignItems}
                        style={{
                            ...sectionClass,
                            overflow: "unset"
                        }}>
                        {newSectionItems.map((item, index) => addItemToSection(qnr, item, pageNum, sectionNum, index, numberOfPages, sectionClass))}
                    </Grid>
                </div>
            );
        }
        else {

            return (
                <div id={divAndKeyName} key={divAndKeyName} style={{display: showGroupUtil.showGroup(qnr, ddo.getObjValue(sectionItems[0], ddo.OBJ.KEY.PAGE.SECTION.ITEM.QUESTION.SHOW_GROUP_KEY)) ? "inline" : "none"}}>
                    <Grid
                        id={"OuterGridC-" + pageNum + "-" + sectionNum}
                        key={"Section-" + pageNum + "-" + sectionNum}
                        container
                        justifyContent={justify}
                        alignItems={alignItems}
                        style={{...sectionClass, overflow: "unset"}}>
                        {sectionItems.map((item, index) => addItemToSection(qnr, item, pageNum, sectionNum, index, numberOfPages, sectionClass))}
                    </Grid>
                </div>
            );
        }
    };


    const addItemToSection  = (qnr, itemObj, pageNum, sectionNum, itemNum, numberOfPages, sectionClass) => {

        // -------------------------------------------------------------------------------------------------------------
        // Calculate pages numbers depending on if there is a start and/or close page
        // -------------------------------------------------------------------------------------------------------------

        let currPageDisplayNumber = tag.metadataExists(qnr, portalShared.CUSTOM_QNR_START_PAGE_OBJ) ? pageNum : (pageNum + 1);
        let currPageDisplayOfNumber = numberOfPages;

        // if (tag.metadataExistsObj(qnr, portalShared.CUSTOM_QNR_START_PAGE_OBJ)) {
        //     currPageDisplayOfNumber -= 1;
        // }
        // if (!(tag.metadataExistsObj(qnr, portalShared.CUSTOM_QNR_CLOSE_PAGE_OBJ) || tag.metadataExistsObj(qnr, portalShared.CUSTOM_QNR_CLOSE_PAGE_OBJ_LEGACY))) {
        //     currPageDisplayOfNumber -= 1;
        // }

        // -------------------------------------------------------------------------------------------------------------

        let titlesObj = ddo.convertTitleSourceReturnTitlesObj(qnr, itemObj, currPageDisplayNumber, currPageDisplayOfNumber, ("-p" + pageNum + "-s" + sectionNum + "-i" + itemNum));

        // Special condition if the title is a question name and it is to be aligned with answer then exit out of title generation.
        // if ((itemObj.source === ddo.TITLE.SOURCE.QUE_NAME) && (tag.metadataExists(titlesObj.question, portalShared.DISPLAY_DEF_ALIGN_ANSWERS_WITH_QUESTION))) {
        //     return;
        // }

        let htmlObj = null;
        let CustomTypographyStyle = null;
        let customLeftObj = null;
        let customCenterObj = null;
        let customRightObj = null;
        // let customLeftObj2 = null;
        // let customCenterObj2 = null;
        // let customRightObj2 = null;
        let customObj = null;


        let itemType = ddo.getSectionItemType(itemObj); // Title, Button or Question

        switch(itemType) {
            case ddo.OBJ.TYPE.SECTION_ITEM.TITLE:

                // itemType TITLE can be for category title bar, headers or footers or spacers

                let variant = ddo.getObjValue(itemObj, ddo.OBJ.KEY.PAGE.SECTION.ITEM.TITLE.VARIANT); // Variant can be single variant i.e. h5 or custom object

                // Note: if variant is a custom object then custom convertedVariant will be blank
                let convertedVariant = (typeof variant === "object") ? "" : font.getDefaultVariantForItem(ddo.OBJ.TYPE.SECTION_ITEM.TITLE, variant);

                let fontObj = font.getFontObjFromVariant(convertedVariant); // MUI 5 converted to using fontsize in rem not pt, and our CSS not working this it to override

                let requiredIndicatorFontSize = requiredUtil.getRequiredIndicatorFontSize(fontObj.fontSize);

                // Check default text to see if custom styling requested
                if (itemObj.source === "D") {

                    if (tag.metadataExists(qnr, portalShared.CUSTOM_DDO_DEFAULTS)) {

                        variant = tag.metadataValue(qnr, portalShared.CUSTOM_DDO_DEFAULTS);
                        // format = ddo.TITLE.FORMAT.CUSTOM; //format assigned before created
                    }
                }

                let showGroupKey = showGroupUtil.getShowGroupKey(qnr, titlesObj.question, itemObj);

                let showGroupVisibleFlag = showGroupUtil.showGroup(qnr, showGroupKey);

                //let showGroupObjArray = ddo.getObjValue(itemObj, ddo.OBJ.KEY.PAGE.SECTION.ITEM.TITLE.SHOW_GROUP_OBJ_ARRAY);

                let uploadedImageStyles = {
                    verticalAlign: 'middle',
                    height: '60px'
                };

                // -----------------------------------------------------------------------------------------------------

                let format = ddo.getObjValue(itemObj, ddo.OBJ.KEY.PAGE.SECTION.ITEM.TITLE.FORMAT);
//debugger; // Q-NUM
                switch (format) {

                    case ddo.TITLE.FORMAT.SPACER:
                        htmlObj = <Grid style={sectionClass} key={titlesObj.itemObj.id} container item sm={12}></Grid>;
                        break;

                    case ddo.TITLE.FORMAT.CATEGORY_TITLE_BAR:  // =================================== CATEGORY TITLE BAR

                        htmlObj = getCategoryTitleBar(qnr, titlesObj.textObj, itemObj, convertedVariant, uploadedImageStyles, titlesObj.itemObj.id, itemObj.pageNum, numberOfPages);
                        break;

                    case ddo.TITLE.FORMAT.PAGE_HEADER:
                    case ddo.TITLE.FORMAT.PAGE_FOOTER1:
                    case ddo.TITLE.FORMAT.PAGE_FOOTER2:

                        let objName = {
                            [ddo.TITLE.FORMAT.PAGE_HEADER]: "pageHeader",
                            [ddo.TITLE.FORMAT.PAGE_FOOTER1]: "pageFooter1",
                            [ddo.TITLE.FORMAT.PAGE_FOOTER2]: "pageFooter2",
                        }

                        let mainPagesObj = {};
                        if (tag.metadataExists(qnr, portalShared.CUSTOM_QNR_MAIN_PAGES_OBJ)) {
                            mainPagesObj = tag.metadataValueObj(qnr, portalShared.CUSTOM_QNR_MAIN_PAGES_OBJ);
                        }

                        customLeftObj = custom.getCustomTitleTypographyFromObject(qnr, mainPagesObj, "left", objName[format] + "LeftTextObj", pageNum, numberOfPages);
                        customCenterObj = custom.getCustomTitleTypographyFromObject(qnr, mainPagesObj, "center", objName[format] + "CenterTextObj", pageNum, numberOfPages);
                        customRightObj = custom.getCustomTitleTypographyFromObject(qnr, mainPagesObj, "right", objName[format] + "RightTextObj", pageNum, numberOfPages);

                        htmlObj =
                            <Grid style={sectionClass} key={format + "-" + titlesObj.itemObj.id} container item sm={12}>

                                <div style={{display: "inline-flex", width: "100%"}}>

                                    <div style={{
                                        width: "30%",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "left",
                                        alignItems: "center"
                                    }}>

                                        {titlesObj.textObj.titleLeftIsImage ?
                                            <img src={imageDataUri(titlesObj.textObj.titleLeft)} alt=""
                                                 style={uploadedImageStyles}/>
                                            :
                                            customLeftObj.useCustom ?
                                                <customLeftObj.customTypography>{customLeftObj.title}</customLeftObj.customTypography>
                                                :
                                                <Typography
                                                    variant={itemObj.variant}>{titlesObj.textObj.titleLeft}</Typography>
                                        }
                                    </div>

                                    <div style={{
                                        width: "40%",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}>

                                        {titlesObj.textObj.titleCenterIsImage ?
                                            <img src={imageDataUri(titlesObj.textObj.titleCenter)} alt="" style={uploadedImageStyles}/>
                                            :
                                            customCenterObj.useCustom ?
                                                <customCenterObj.customTypography>{customCenterObj.title}</customCenterObj.customTypography>
                                                :
                                                <Typography variant={itemObj.variant}>{titlesObj.textObj.titleCenter}</Typography>
                                        }
                                    </div>

                                    <div style={{
                                        width: "30%",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "right",
                                        alignItems: "center"
                                    }}>

                                        {titlesObj.textObj.titleRightIsImage ?
                                            <img src={imageDataUri(titlesObj.textObj.titleRight)} alt="" style={uploadedImageStyles}/>
                                            :
                                            customRightObj.useCustom ?
                                                <customRightObj.customTypography>{customRightObj.title}</customRightObj.customTypography>
                                                :
                                                <Typography variant={itemObj.variant}>{titlesObj.textObj.titleRight}</Typography>
                                        }
                                    </div>

                                </div>

                            </Grid>;
                        break;
                    case ddo.TITLE.FORMAT.CUSTOM:

                        customObj = variant;  // Custom object was stored in variant

                        CustomTypographyStyle = custom.getCustomTypography(customObj);

                        let skipName = false;

                        // if ((titlesObj.source === ddo.TITLE.SOURCE.QUE_NAME)||(titlesObj.source === ddo.TITLE.SOURCE.QUE_DESC)) {
                        //     // Check for custom question format
                        //     if (tag.metadataExistsObj(titlesObj.question, portalShared.CUSTOM_DDO_QUE_FORMAT)) {
                        //         //debugger; // BLAKE FIX ????
                        //     }
                        // }

                        // if (titlesObj.source === ddo.TITLE.SOURCE.QNR_DESC) {
                        //     if (qnr.description !== "") {
                        //         titlesObj.text = qnr.description;
                        //     }
                        // }

                        // Only Descriptions and Scripts can have leading icons
                        let iconObj = {
                            hasIcon: false,
                            icon: descriptionIcons["InfoIcon"],
                            size: "16px",
                            paddingTop: "2px",
                            color: "black"
                        };

                        if (customObj.hasOwnProperty("iconObj") && customObj.iconObj !== null) {

                            iconObj.hasIcon = customObj.iconObj.icon !== "none";
                            if (iconObj.hasIcon) {
                                iconObj.icon = descriptionIcons[customObj.iconObj.icon]; // Get the icon from const JSON obj declared above
                                iconObj.size = customObj.iconObj.size + "px";
                                iconObj.paddingTop = customObj.iconObj.padding + "px";
                                iconObj.color = customObj.iconObj.hasOwnProperty("colorEntry") ? portalShared.getColor(customObj.iconObj) : "black"; // Legacy FIX
                            }
                        }
                        else if (titlesObj.isDescription) {
                            iconObj.hasIcon = true; // LEGACY FIX by default I decided to NOT show info icon on questionnaire description if there is an older version of the custom object
                        }

                        let CustomIcon = styled(iconObj.icon)({color: iconObj.color});

                        if (!skipName) {
                            htmlObj = <Grid key={"TitleCustom-" + titlesObj.objKey} item sm={12} style={{
                                ...sectionClass,
                                display: showGroupVisibleFlag ? "inline" : "none", width: "100%"
                            }}>
                                <div style={{display: "flex", width: "100%", justifyContent: customObj.textAlign, alignItems: "center"}}>
                                    <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: customObj.textAlign,
                                        width: "100%",
                                        paddingLeft: customObj.hasOwnProperty("indent") ? (customObj.indent + "px") : "0px"
                                    }}>

                                        <div style={{display: (iconObj.hasIcon) ? "inline" : "none"}}>
                                            <CustomIcon sx={{
                                                height: iconObj.size,
                                                width: iconObj.size,
                                                paddingTop: iconObj.paddingTop
                                            }}/>
                                        </div>
                                        <div style={{display: (iconObj.hasIcon) ? "inline" : "none"}}>
                                            &nbsp;
                                        </div>
                                        <CustomTypographyStyle>{titlesObj.text}</CustomTypographyStyle>
                                        <Typography fontSize={requiredIndicatorFontSize} fontStyle={fontObj.fontStyle} color={portalShared.MUI_ERROR_DARK}>{requiredUtil.isQuestionAnswered(props.dataDefObjFromStore, itemObj, qnr) ? "" : titlesObj.itemObj.requiredIndicator}</Typography>
                                    </div>
                                </div>

                            </Grid>;
                        }

                        break;
                    case ddo.TITLE.FORMAT.PLAIN:

                        // If text is "TYPOGRAPHY" Then display defaults chart

                        if ((titlesObj.text !== undefined) && (titlesObj.text.toUpperCase() === "TYPOGRAPHY")) {
                            htmlObj = font.displayDefaultTypographyDetails(pageNum, sectionNum, itemNum);
                        }
                        else {

                            htmlObj = <Grid key={"TitlePlainLeft-" + (titlesObj.itemObj.id === null ? titlesObj.itemObj.source : "") + itemNum} item sm={12} style={{...sectionClass, width: "100%", display: showGroupVisibleFlag ? "inline" : "none"}}>
                                <div style={{textAlign: "left", width: "100%", display: "flex", justifyContent: "left", alignItems: "center"}}>
                                    <Typography fontSize={fontObj.fontSize} fontStyle={fontObj.fontStyle} color={fontObj.fontColor}>{titlesObj.text}</Typography>
                                    <div>&nbsp;</div>
                                    <Typography fontSize={requiredIndicatorFontSize} fontStyle={fontObj.fontStyle} color={portalShared.MUI_ERROR_DARK}>{requiredUtil.isQuestionAnswered(props.dataDefObjFromStore, itemObj, qnr) ? "" : titlesObj.itemObj.requiredIndicator}</Typography>
                                </div>
                            </Grid>;
                        }
                        break;
                    case ddo.TITLE.FORMAT.PLAIN_CENTER:
                        // ToDo ZZZZZ if there is a description wait to do gray bar labels

                        htmlObj = <Grid key={"TitlePlainCenter-" + titlesObj.itemObj.id} item sm={12} style={{...sectionClass, display: showGroupVisibleFlag ? "inline" : "none"}}>
                            <div style={{textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center"}}>
                                <Typography fontSize={fontObj.fontSize} fontStyle={fontObj.fontStyle} color={fontObj.fontColor}>{titlesObj.text}</Typography>
                                <div>&nbsp;</div>
                                <Typography fontSize={requiredIndicatorFontSize} fontStyle={fontObj.fontStyle} color={portalShared.MUI_ERROR_DARK}>{titlesObj.itemObj.requiredIndicator}</Typography>
                            </div>
                        </Grid>;
                        break;
                    case ddo.TITLE.FORMAT.PLAIN_RIGHT:
                        // ToDo ZZZZZ if there is a description wait to do gray bar labels

                        htmlObj = <Grid key={"TitlePlainRight-" + titlesObj.itemObj.id} item sm={12} style={{...sectionClass, display: showGroupVisibleFlag ? "inline" : "none"}}>
                            <div style={{textAlign: "right", display: "flex", justifyContent: "right", alignItems: "center"}}>
                                <Typography fontSize={fontObj.fontSize} fontStyle={fontObj.fontStyle} color={fontObj.fontColor}>{titlesObj.text}</Typography>
                                <div>&nbsp;</div>
                                <Typography fontSize={requiredIndicatorFontSize} fontStyle={fontObj.fontStyle} color={portalShared.MUI_ERROR_DARK}>{titlesObj.itemObj.requiredIndicator}</Typography>
                            </div>
                        </Grid>;
                        break;

                    case ddo.TITLE.FORMAT.METADATA:
                        // This is used to format the metadata display at the top of a readonly survey ????? ZZZZZ YYYYY QQQQQ
                        // METADATA used to allow titles to have text|variant I don't think this will be needed anymore ZZZZZ
                        let tagName = titlesObj.text.substring(0, titlesObj.text.indexOf("|"));
                        let valueName = titlesObj.text.substring(titlesObj.text.indexOf("|") + 1);

                        fontObj = font.getFontObjFromVariant(font.VARIANT.CAPTION);

                        htmlObj = <Grid key={"TitleFormatMetadata-" + itemNum} item container sm={12} style={{...sectionClass, display: "inline"}}>
                            <div style={{float: "left"}}>
                                <Typography fontSize={fontObj.fontSize} fontStyle={fontObj.fontStyle} color={fontObj.fontColor}>{tagName}</Typography>
                            </div>
                            <div style={{float: "left"}}>
                                {":"}&nbsp;&nbsp;
                            </div>
                            <div style={{float: "left"}}>
                                <Typography fontSize={fontObj.fontSize} fontStyle={fontObj.fontStyle} color={fontObj.fontColor}><b>{valueName}</b></Typography>
                            </div>
                        </Grid>;
                        break;
                    default:
                        break;
                }
                break;

            case ddo.OBJ.TYPE.SECTION_ITEM.BUTTON:

                let btnName = ddo.getObjValue(itemObj, ddo.OBJ.KEY.PAGE.SECTION.ITEM.BUTTON.NAME);
                let btnMode = ddo.getObjValue(itemObj, ddo.OBJ.KEY.PAGE.SECTION.ITEM.BUTTON.MODE);
                btnName = ddo.convertButtonNameDefault(btnName, btnMode);

                let onClickFunction = function () {};
                let allRequiredAnswered = requiredUtil.buttonCheckForAllRequiredAnswered(props.dataDefObjFromStore, qnr);
                let allRequiredAnsweredOnPage = requiredUtil.buttonCheckForAllRequiredAnsweredOnPage(props.dataDefObjFromStore, pageNum, qnr);
                let disableButton = false;

                switch (btnMode) {
                    case ddo.BUTTON.MODE.START:
                        onClickFunction = props.start;
                        break;
                    case ddo.BUTTON.MODE.CANCEL:
                        onClickFunction = props.cancel;
                        break;
                    case ddo.BUTTON.MODE.NEXT:
                        onClickFunction = props.next;
                        disableButton = !allRequiredAnsweredOnPage;
                        break;
                    case ddo.BUTTON.MODE.PREVIOUS:
                        onClickFunction = props.previous;
                        break;
                    case ddo.BUTTON.MODE.FINISH:
                        if (props.surveyEditMode === portalShared.READONLY_SURVEY) {
                            return "";  // No submit button in readonly
                        }
                        if (!props.portalPreview) {
                            onClickFunction = props.finish; // Don't allow the submit onClick in PortalPreview
                        }
                        disableButton = !allRequiredAnswered;
                        break;
                    case ddo.BUTTON.MODE.CLOSE:
                        onClickFunction = props.closeSurvey;
                        break;
                    default:
                        break;
                }

                let btnKeyQualifier =  titlesObj.itemObj.mode + "-" + pageNum + "-" + sectionNum + "-" + itemNum;

                // let ariaLabel = this.getAriaLabelForButton(btnMode, btnName); NOTE: This does not appear to work for buttons

                if (disableButton) {

                    let fontFamily = null;

                    if (tag.metadataExistsObj(qnr, portalShared.CUSTOM_QNR_SYSTEM_OBJ)) {
                        let customSystemObj = tag.metadataValueObj(qnr, portalShared.CUSTOM_QNR_SYSTEM_OBJ);
                        fontFamily =  portalShared.getFontFamily(customSystemObj.systemButtons.text.font);
                    } else {
                        fontFamily =  portalShared.DEFAULT_FONT_FAMILY;
                    }


                    let type = portalShared.DEFAULT_BUTTON_TYPE_PORTAL; // text, outlined, contained

                    // Looks like when a button is disabled there are no hover effects
                    let fontWeight = portalShared.DEFAULT_FONT_WEIGHT
                    let fontColor = portalShared.DEFAULT_BUTTON_DISABLED_PORTAL;
                    let fontWeightHover = portalShared.DEFAULT_FONT_WEIGHT;
                    let fontColorHover = portalShared.COLOR_WHITE_HEX;
                    let backgroundColor = portalShared.COLOR_WHITE_HEX;
                    let backgroundColorHover = portalShared.COLOR_LIGHT_GRAY_HEX;
                    let borderColor = portalShared.COLOR_WHITE_HEX;
                    let borderColorHover = portalShared.COLOR_WHITE_HEX;

                    const SystemButton = styled(Button)({
                        "&:hover": {
                            borderColor: borderColorHover,
                            backgroundColor: backgroundColorHover,
                            //color: fontColorHover,
                        }});

                    htmlObj = <div>
                        <Grid key={"Button-" + btnKeyQualifier} item display="flex" justifyContent="center" alignItems="center">
                            <SystemButton
                                variant={type}
                                sx={{borderColor: borderColor, backgroundColor: backgroundColor, width: "100px"}}
                                disableElevation={true}
                                onClick={onClickFunction}
                                tabIndex={props.tabIndex}
                                disabled={disableButton}
                            >
                                <Typography fontFamily={fontFamily} color={fontColor} fontWeight={fontWeight} sx={{
                                    "&:hover": {
                                        color: fontColorHover,
                                        fontWeight: fontWeightHover
                                    }
                                }}>{btnName}</Typography>
                            </SystemButton>

                        </Grid>
                        {disableButton ? <div style={{color: portalShared.MUI_ERROR_DARK, alignItems: "center"}}>*Required fields must be answered</div> : <div>&nbsp;</div>}
                    </div>;

                }
                else if (tag.metadataExistsObj(qnr, portalShared.CUSTOM_QNR_SYSTEM_OBJ)) {

                    let customSystemObj = tag.metadataValueObj(qnr, portalShared.CUSTOM_QNR_SYSTEM_OBJ);

                    let type = customSystemObj.systemButtons.type; // text, outlined, contained
                    let fontFamily =  portalShared.getFontFamily(customSystemObj.systemButtons.text.font);
                    let fontWeight = customSystemObj.systemButtons.text.fontWeight; //

                    let fontColor = portalShared.getColor(customSystemObj.systemButtons.text.colorObj);
                    let fontWeightHover = customSystemObj.systemButtons.textHover.fontWeight;
                    let fontColorHover = portalShared.getColor(customSystemObj.systemButtons.textHover.colorObj);
                    let backgroundColor = portalShared.getColor(customSystemObj.systemButtons.backgroundColor);
                    let backgroundColorHover = portalShared.getColor(customSystemObj.systemButtons.backgroundColorHover);
                    let borderColor = portalShared.getColor(customSystemObj.systemButtons.borderColor);
                    let borderColorHover = portalShared.getColor(customSystemObj.systemButtons.borderColorHover);

                    const SystemButton = styled(Button)({
                        "&:hover": {
                            borderColor: borderColorHover,
                            backgroundColor: backgroundColorHover,
                            //color: fontColorHover,
                        }});

                    htmlObj = <div>
                        <Grid key={"Button-" + btnKeyQualifier} item display="flex" justifyContent="center" alignItems="center">
                                <SystemButton
                                    variant={type}
                                    sx={{borderColor: borderColor, backgroundColor: backgroundColor, width: "100px"}}
                                    disableElevation={true}
                                    onClick={onClickFunction}
                                    tabIndex={props.tabIndex}
                                >
                                    <Typography fontFamily={fontFamily} color={fontColor} fontWeight={fontWeight} sx={{
                                        "&:hover": {
                                            color: fontColorHover,
                                            fontWeight: fontWeightHover
                                        }
                                    }}>{btnName}</Typography>
                                </SystemButton>
                        </Grid>
                        {disableButton ? <div style={{color: portalShared.MUI_ERROR_DARK, alignItems: "center"}}>*Required fields must be answered</div> : <div>&nbsp;</div>}
                    </div>

                } else {

                    // NOT a custom button --------------------------------------------------------

                    const SystemButton = styled(Button)({
                        "&:hover": {
                            color: "green",
                            borderColor: portalShared.COLOR_WHITE_HEX,
                            backgroundColor: portalShared.COLOR_LIGHT_GRAY_HEX,
                        }});

                    htmlObj = <div>
                        <Grid key={"Button-" + btnKeyQualifier} item display="flex" justifyContent="center"
                                         alignItems="center">
                            <SystemButton
                                variant={"text"}

                                sx={{backgroundColor: portalShared.COLOR_WHITE_HEX, width: "100px"}}
                                disableElevation={true}
                                onClick={onClickFunction}
                                tabIndex={props.tabIndex}
                            >
                                <Typography color={portalShared.COLOR_DEFAULT_BLUE_HEX} sx={{
                                    "&:hover": {
                                        color: portalShared.COLOR_DEFAULT_BLUE_HEX,
                                        fontStyle: "bold"
                                    }
                                }}>{btnName}</Typography>
                            </SystemButton>
                        </Grid>
                        {disableButton ? <div style={{color: portalShared.MUI_ERROR_DARK, alignItems: "center"}}>*Required fields must be answered</div> : <div>&nbsp;</div>}
                    </div>
                }

                break;

            case ddo.OBJ.TYPE.SECTION_ITEM.QUESTION:

                titlesObj.questionId = ddo.getObjValue(itemObj, ddo.OBJ.KEY.PAGE.SECTION.ITEM.QUESTION.ID);
                titlesObj.question = ddo.getQuestion(qnr, titlesObj.questionId);
                let questionShowGroupKey = ddo.getObjValue(itemObj, ddo.OBJ.KEY.PAGE.SECTION.ITEM.QUESTION.SHOW_GROUP_KEY);
                //let questionShowGroupObjArray = ddo.getObjValue(itemObj, ddo.OBJ.KEY.PAGE.SECTION.ITEM.QUESTION.SHOW_GROUP_OBJ_ARRAY);
                titlesObj.qNum = ddo.getObjValue(itemObj, ddo.OBJ.KEY.PAGE.SECTION.ITEM.QUESTION.SHOW_NUMBER);

                htmlObj =  <Grid key={"QuestionGrid-" + titlesObj.itemObj.id + "-" + itemNum} item style={{...sectionClass, width: "100%", minHeight: "fit-content", display: showGroupUtil.showGroup(qnr, questionShowGroupKey) ? "inline" : "none"}} xs={12}>
                    <PortalQuestion key={"Question-" + titlesObj.question.id + "-" + itemNum}
                                    questionnaire={qnr}
                                    dataDefObj={props.dataDefObjFromStore}
                                    showGroupKey={questionShowGroupKey}
                                    question={titlesObj.question}
                                    questionNumber={titlesObj.qNum}
                                    itemObj={itemObj}
                                    answerQuestionOptions={props.answerQuestionOptions}
                                    answerQuestionTemplateOptions={props.answerQuestionTemplateOptions}
                                    answerQuestionText={props.answerQuestionText}
                                    answerQuestionTextInStore={props.answerQuestionTextInStore}
                                    answerQuestionTemplateText={props.answerQuestionTemplateText}
                                    displayMode={props.displayMode}
                                    surveyEditMode={props.surveyEditMode}
                                    theme={props.theme}
                                    tabIndex={props.tabIndex}
                                    pageNum={pageNum}
                                    onChangeQuestionText={props.onChangeQuestionText}
                        //likertIndex={index}
                        //surveyEditMode={this.props.surveyEditMode}
                    />
                </Grid>;
                break;

            case ddo.OBJ.TYPE.SECTION_ITEM.LIKERT_GROUP:

                let likertGroup = ddo.getGroupById(qnr, itemObj[ddo.OBJ.KEY.PAGE.SECTION.ITEM.LIKERT_GROUP.ID]);
                let likertQuestions = ddo.getLikertGroupQuestions(itemObj);
                //let likertShowGroupKey = itemObj.questions[0].showGroupKey; ToDo ZZZZZ this needs to return by question and ignore if metadata says to since LIKERTS only have one answers set and multiple questions
                //let likertShowGroupObjArray = itemObj.questions[0].showGroupObjArray;

                htmlObj =  <Grid key={"Likert-" + titlesObj.itemObj.id} item style={{...sectionClass, width: "100%", minHeight: "fit-content", display: 'inline'}} xs={12}>
                    {likertQuestions.map((questionItemObj, index) =>
                        <PortalQuestion     key={"LikertQuestion-" + index + "-" + questionItemObj.id}
                                            questionnaire={qnr}
                                            dataDefObj={props.dataDefObjFromStore}
                                            showGroupKey={ddo.getLikertQuestionShowGroupKey(qnr, questionItemObj)}
                                            group={likertGroup}
                                            question={ddo.getQuestion(qnr, questionItemObj[ddo.OBJ.KEY.PAGE.SECTION.ITEM.QUESTION.ID])}
                                            questionNumber={questionItemObj.showNumber}
                                            itemObj={itemObj}
                                            answerQuestionOptions={props.answerQuestionOptions}
                                            answerQuestionTemplateOptions={props.answerQuestionTemplateOptions}
                                            answerQuestionText={props.answerQuestionText}
                                            answerQuestionTextInStore={props.answerQuestionTextInStore}
                                            answerQuestionTemplateText={props.answerQuestionTemplateText}
                                            theme={props.theme}
                                            likertIndex={index}
                                            displayMode={props.displayMode}
                                            surveyEditMode={props.surveyEditMode}
                                            tabIndex={props.tabIndex}
                                            pageNum={pageNum}
                                            onChangeQuestionText={props.onChangeQuestionText}
                        />
                    )}
                </Grid>;
                break;
            case ddo.OBJ.TYPE.SECTION_ITEM.ICON:

                htmlObj = <div key="GreenCheckIcon" style={{display: "flex", justifyContent: "center"}}><img src={green_checkmark} alt="Green check mark logo for questionnaire complete"/></div>;
                break;
            default:

                break;
        }

        return htmlObj;
    };


    // -----------------------------------------------------------------------------------------------------------------
    // RENDER
    // -----------------------------------------------------------------------------------------------------------------

    let pageSections = props.pageDefObj[ddo.OBJ.KEY.DDO.PAGE_SECTION_ARRAY];

    let qnr = getQnrObj(); // Get Questionnaire Obj (Instance or Template)

    return (
        ((props.questionnaireInstance) || (props.questionnaireTemplate && qnr?.questionCategoryTemplates)) &&
        <form key={"MainForm-id-" + qnr.id + "-portalCount-" + props.portalCount}>
            {pageSections.map((section, index) =>
                addSectionToPage(qnr, section, props.pageDefObjCurrIndex, index, props.totalPages)
            )}
        </form>
    );
}

PortalPageRenderer.defaultProps = {
    showProgress: true,
    questionnaireInstance: null,
    questionnaireTemplate: null,
    tabIndex: 0
};


PortalPageRenderer.propTypes = {
    //classes: PropTypes.object.isRequired,
    pageDefObj: PropTypes.object.isRequired,
    pageDefObjCurrIndex: PropTypes.number,
    totalPages: PropTypes.number,
    questionnaireInstance: PropTypes.object,
    questionnaireTemplate: PropTypes.object,
    questionnaire: PropTypes.object,
    start: PropTypes.func,
    cancel: PropTypes.func,
    finish: PropTypes.func,
    next: PropTypes.func,
    previous: PropTypes.func,
    history: PropTypes.object,
    portal: PropTypes.object,
    displayMode: PropTypes.string,
    surveyEditMode: PropTypes.string,
    templateType: PropTypes.string,
    portalPreview: PropTypes.bool,
    portalCount: PropTypes.number,
    tabIndex: PropTypes.number
};

function mapStateToProps(state) {
    return {
        theme: state.theme,
        questionnaireTemplateFromStore: state.portal.questionnaireTemplate,
        dataDefObjFromStore: state.portal.dataDefObj
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        dispatch,
        answerQuestionOptions,
        answerQuestionTemplateOptions,
        answerQuestionText,
        answerQuestionTextInStore,
        answerQuestionTemplateText,
        onChangeQuestionText
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PortalPageRenderer);
